(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

var $41765ca06fd0efec$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"EVgbq":"index.e92f0e18.js","947Iz":"snoozer.a36450ca.png","12Neq":"index.e2c30620.css"}'));

})();
//# sourceMappingURL=index.5123a754.js.map
